import { createRouter, createWebHistory } from 'vue-router';
import Start from './views/Start.vue';
import Veranstaltungen from './views/Veranstaltungen.vue';
import Kurse from './views/Kurse.vue';
import Kontakt from './views/Kontakt.vue';
import Impressum from './views/Impressum.vue';
import Datenschutz from './views/Datenschutz.vue';


const routes = [
    {
        path: '/',
        name: 'start',
        component: Start,
        meta: {
            metaTitle: 'Koblenz mit Baby',
            metaDescription: 'Aktuelle Veranstaltungen, Kurse, Tipps und Austausch für (werdende) Eltern aus Koblenz in der WhatsApp-Community "Koblenz mit Baby"',
            pageUrl: 'https://koblenz-mit-baby.de/',
            metaKeywords: 'Koblenz, Baby, Kurse, Veranstaltungen, News, Tipps, Austausch, WhatsApp-Community, Eltern, Kinder, Familienberatung, Elternkurse, Babykurse, Aktuelles, Termine',
            ogImage: 'https://koblenz-mit-baby.de/og-image.png'
        }
    },
    {
        path: '/veranstaltungen/',
        name: 'veranstaltungen',
        component: Veranstaltungen,
        meta: {
            metaTitle: 'Veranstaltungen für alle in Koblenz mit Baby',
            metaDescription: 'Koblenz mit Baby - Veranstaltungen, Events, Aktuelles',
            pageUrl: 'https://koblenz-mit-baby.de/veranstaltungen/',
            metaKeywords: 'Koblenz, Baby, Kurse, Veranstaltungen, News, Tipps, Austausch, WhatsApp-Community, Eltern, Kinder, Familienberatung, Veranstaltungen für Eltern, Veranstaltungen für Baby, Aktuelles, Termine',
            ogImage: 'https://koblenz-mit-baby.de/og-image.png'
        }
    },
    {
        path: '/kurse/',
        name: 'kurse',
        component: Kurse,
        meta: {
            metaTitle: 'Babykurse & Elternkurse in Koblenz',
            metaDescription: 'Koblenz mit Baby - Kurse und fortlaufende Angebote',
            pageUrl: 'https://koblenz-mit-baby.de/kurse/',
            metaKeywords: 'Koblenz, Baby, Kurse, Veranstaltungen, News, Tipps, Austausch, WhatsApp-Community, Eltern, Kinder, Familienberatung, Elternkurse, Babykurse, Aktuelles, Termine',
            ogImage: 'https://koblenz-mit-baby.de/og-image.png'
        }
    },
    {
        path: '/kontakt/',
        name: 'kontakt',
        component: Kontakt,
        meta: {
            metaTitle: 'Kontakt – Koblenz mit Baby',
            metaDescription: 'Habt ihr Fragen zur Community? Ich freue ich mich auf eure Nachricht.',
            metaKeywords: 'Kontakt, Beratung anfragen, Kursanmeldung, Stillberatung Koblenz, Elternberatung, Maike Röhrig, Koblenz, Baby',
            pageUrl: 'https://koblenz-mit-baby.de/kontakt/',
            ogImage: 'https://koblenz-mit-baby.de/og-image.png'
        }
    },
    {
        path: '/impressum/',
        name: 'impressum',
        component: Impressum,
        meta: {
            metaTitle: 'Impressum - Koblenz mit Baby',
            metaDescription: 'Impressum - Koblenz mit Baby',
            pageUrl: 'https://koblenz-mit-baby.de/impressum/',
            metaKeywords: 'Impressum, rechtliche Informationen, Anbieterkennzeichnung',
            ogImage: 'https://koblenz-mit-baby.de/og-image.png'
        }
    },
    {
        path: '/datenschutz/',
        name: 'datenschutz',
        component: Datenschutz,
        meta: {
            metaTitle: 'Datenschutz - Koblenz mit Baby',
            metaDescription: 'Datenschutz - Koblenz mit Baby',
            pageUrl: 'https://koblenz-mit-baby.de/datenschutz/',
            metaKeywords: 'Datenschutz, DSGVO, Datenschutzrichtlinien, Datenverarbeitung',
            ogImage: 'https://koblenz-mit-baby.de/og-image.png'
        }
    }
];

const router = createRouter({
    history: createWebHistory(process.env.BASE_URL),
    routes,
    scrollBehavior(to, from, savedPosition) {
        if (savedPosition) {
            return savedPosition; // Falls die Position gespeichert ist (z.B. bei "Zurück" in der Historie)
        } else {
            return { top: 0 }; // Scrollt immer zum Seitenanfang
        }
    }
});

router.beforeEach((to, from, next) => {
  if (!to.path.endsWith("/") && to.path !== "/") {
    next({ path: to.path + "/", query: to.query, hash: to.hash });
  } else {
    next();
  }
});

router.afterEach((to) => {
    document.title = to.meta.metaTitle || 'Koblenz mit Baby';

    const descriptionTag = document.querySelector("meta[name='description']");
    if (descriptionTag) {
        descriptionTag.setAttribute("content", to.meta.metaDescription || '');
    }

    const keywordsTag = document.querySelector("meta[name='keywords']");
    if (keywordsTag) {
        keywordsTag.setAttribute("content", to.meta.metaKeywords || '');
    } else {
        const newKeywordsTag = document.createElement("meta");
        newKeywordsTag.setAttribute("name", "keywords");
        newKeywordsTag.setAttribute("content", to.meta.metaKeywords || '');
        document.head.appendChild(newKeywordsTag);
    }

    const ogTitle = document.querySelector("meta[property='og:title']");

    if (ogTitle) ogTitle.setAttribute("content", to.meta.metaTitle || '');


    const ogDescription = document.querySelector("meta[property='og:description']");

    if (ogDescription) ogDescription.setAttribute("content", to.meta.metaDescription || '');


    const ogUrl = document.querySelector("meta[property='og:url']");
    
    if (ogUrl) ogUrl.setAttribute("content", to.meta.pageUrl || '');
    

    const ogImage = document.querySelector("meta[property='og:image']");
    if (ogImage) ogImage.setAttribute("content", to.meta.ogImage || '');

    let canonicalTag = document.querySelector("link[rel='canonical']");
    if (!canonicalTag) {
        canonicalTag = document.createElement("link");
        canonicalTag.setAttribute("rel", "canonical");
        document.head.appendChild(canonicalTag);
    }
    canonicalTag.setAttribute("href", to.meta.pageUrl || window.location.href);
});


export default router;
